import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHome: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconHome"><Path fillRule="evenodd" clipRule="evenodd" d="M10.8918 1.68763C11.5365 1.16019 12.4635 1.1602 13.1082 1.68763L20.3582 7.61945C20.7644 7.95182 21 8.44899 21 8.97387V19.25C21 20.2165 20.2165 21 19.25 21H4.75C3.7835 21 3 20.2165 3 19.25V8.97387C3 8.44899 3.2356 7.95182 3.64183 7.61945L10.8918 1.68763Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHome;
